import { render, staticRenderFns } from "./ImagePopUp.vue?vue&type=template&id=51e2df49"
import script from "./ImagePopUp.vue?vue&type=script&lang=js"
export * from "./ImagePopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports